import {
  type GeneralParticipationInfoApiResponse,
  type Shop,
} from '~/features/general-participation/types/general-participation'
import { END_POINTS, get } from '~/shared/http-client/api'

export const getGeneralParticipationInfo = async (): Promise<Shop> => {
  const response: GeneralParticipationInfoApiResponse = await get(
    END_POINTS.generalParticipationInfo.shop,
  )

  return response.data
}
